"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.costReports.title': 'Cost Reports',
    'reports.costReports.description': 'View AI usage costs and analytics',
};
